import { useCurrentUserQuery } from '@/modules/auth/queries/user.tsx';
import { PageLayout } from 'ui';

const IssuerAbsentRegisters = () => {
  const { data } = useCurrentUserQuery();

  return (
    <PageLayout title="Registers are not added">
      <div className="w-full h-full flex items-center justify-center">
        <p className="max-w-4xl text-xl text-center">
          Hey {data?.first_name}, you have not been added to any registers (funds or companies).
          Please ask your Compli One contact person to add you to a register in admin panel.
        </p>
      </div>
    </PageLayout>
  );
};

export default IssuerAbsentRegisters;
